<template>
  <section>
    <!--工具条-->
    <el-col :span="24" class="toolbar" style="padding-bottom: 0px;">
      <el-form :inline="true" :model="filters">
        <el-form-item>
          <el-input v-model="filters.keywords" placeholder="名称"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" v-on:click="getAgents">查询</el-button>
        </el-form-item>
      </el-form>
    </el-col>

    <!--列表-->
    <el-table :data="agents" highlight-current-row v-loading="listLoading"  style="width: 100%;" :height="bodyHeight-220">
      <el-table-column type="index" width="60">
      </el-table-column>
      <el-table-column prop="name" label="代理名称" min-width="150">
      </el-table-column>
      <el-table-column prop="identifier" label="标识" min-width="200">
      </el-table-column>
      <el-table-column prop="status" label="状态" width="100" align="center" :formatter="formatStatus">
        <template scope="scope">
          <i :class="formatStatusIcon(scope.row)"></i>
          {{formatStatus(scope.row)}}
        </template>
      </el-table-column>
      <el-table-column label="操作" width="250">
        <template scope="scope">
          <el-button size="small" @click="viewDataSource(scope.$index, scope.row)">数据源</el-button>
          <el-button type="danger" size="small" @click="delAgent(scope.$index, scope.row)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
  </section>
</template>
<style>
  i.Success {
    color: #67C23A
  }
  i.Info {
    color: #909399
  }
</style>

<script>
export default {
  name: 'agentmanage',
  props: ['bodyHeight'],
  data() {
    return {
      filters: {
        keywords: ''
      },
      sels: [],
      listLoading: false,
      agents:[]
    }
  },
    methods: {     
    // 显示转换
    formatStatus: function (row) {
      if (row.status === 0) {
        return '在线'
      } else if (row.status === 1) {
        return '离线'
      } else {
        return '未知'
      }
    },
    // 显示图标
    formatStatusIcon: function (row) {
      if (row.status === 0) {
        return 'el-icon-video-play Success'
      } else if (row.status === 1) {
        return 'el-icon-video-pause Info'
      } else {
        return 'el-icon-info'
      }
    },
    // 获取用户列表
    getAgents: function() { 
      this.$ajax({
        url: 'api/DataCollect/GetAgents',
        method: 'get',
        loadingName: 'listLoading',
        success: (d, r) => {
          this.agents = d
        }
      })
    },
      viewDataSource: function (index, row) {
        this.$router.push({ name: '数据源', params: { agentId: row.agentId } })
    },
    // 删除代理
    delAgent: function (index,row) {
      this.$confirm('确认删除该记录吗?', '提示', {
        type: 'warning'
      }).then(() => {
        this.listLoading = true
        this.$ajax({
          url: `api/DataCollect/DeleteAgent?agentId=${row.agentId}`
        }).then((res) => {
          this.listLoading = false
          this.$message({
            message: '删除成功',
            type: 'success'
          })
          this.getAgents()
        })
      }).catch(() => {
      })
    }
  },
  mounted() {
    this.getAgents()
  }
}
</script>